export default {
  algorithms: {
    complete: {
      en: "Complete",
      pt: "Completar",
    },
    minimizar: {
      en: "Minimize",
      pt: "Minimizar",
    },
    convertAFNDToAFD: {
      en: "NFDA-λ → FDA",
      pt: "AFND-λ → AFD",
    },
    simulate: {
      en: "Simulate automata",
      pt: "Simular autômato",
    },
    regextToAutomata: {
      en: "Regex to automata",
      pt: "Regex para autômato",
    },
    importDot: {
      en: "Import DOT / TIKZ",
      pt: "Importar DOT / TIKZ",
    },
    importGrammar: {
      en: "Import grammar",
      pt: "Importar gramática",
    },
  },
  label: {
    machine: {
      en: "Machine",
      pt: "Máquina",
    },
    grammar: {
      en: "Grammar",
      pt: "Gramática",
    },
  },
  buttonRouter: {
    machine: {
      en: "Go to Draw Screen",
      pt: "Ir para tela de desenho",
    },
    grammar: {
      en: "Go to Grammar Screen",
      pt: "Ir para tela de gramática",
    },
    theProject: {
      en: "The project",
      pt: "O projeto",
    },
    report: {
      en: "Report",
      pt: "Relatório",
    },
  },
  profile: {
    en: "Profile",
    pt: "Perfil",
  },
  howToUse: {
    en: "How to Use",
    pt: "Como usar",
  },
  historic: {
    en: "Historic",
    pt: "Histórico",
  },
  version: {
    en: "Version",
    pt: "Versão",
  },
};
